(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  const initMagazineBlogCarousels = (root = document) => {
    root.querySelectorAll('.magazine-blog__list--carousel').forEach((list) => {
      if (list.dataset.carouselReady === 'true') return;
      list.dataset.carouselReady = 'true';

      const section = list.closest('.magazine-blog');
      if (!section) return;

      const prevButton = section.querySelector('[data-magazine-blog-control="prev"]');
      const nextButton = section.querySelector('[data-magazine-blog-control="next"]');

      const updateButtons = () => {
        const maxScroll = Math.max(list.scrollWidth - list.clientWidth, 0);
        if (prevButton) prevButton.disabled = list.scrollLeft <= 1;
        if (nextButton) nextButton.disabled = list.scrollLeft >= maxScroll - 1;
      };

      const scrollByPage = (direction) => {
        list.scrollBy({ left: direction * list.clientWidth * 0.85, behavior: 'smooth' });
      };

      prevButton?.addEventListener('click', () => scrollByPage(-1));
      nextButton?.addEventListener('click', () => scrollByPage(1));
      list.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      window.addEventListener('load', updateButtons);

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateButtons).observe(list);
      }

      list.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', updateButtons, { once: true });
      });

      updateButtons();
      requestAnimationFrame(updateButtons);
    });
  };

  initMagazineBlogCarousels();
  document.addEventListener('shopify:section:load', (event) => initMagazineBlogCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dual-panel-showcase"] && !Shopify.designMode) return;
  try {
    
  const syncDualPanelContent = (slideshow) => {
    const slider = slideshow.querySelector('.slider');
    const panels = slideshow.parentElement ?. querySelector('[data-dual-panel-content]');
    if (! slider || ! panels) return;
    

    const updatePanels = () => {
      const slides = Array.from(slider.querySelectorAll('.dual-panel-showcase__slide'));
      if (slides.length === 0) return;
      

      const sliderRect = slider.getBoundingClientRect();
      if (sliderRect.width === 0) return;
      

      const sliderCenter = sliderRect.left + sliderRect.width / 2;

      let activeIndex = 0;
      let smallestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        if (slideRect.width === 0) return;
        

        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(sliderCenter - slideCenter);

        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex = index;
        }
      });

      panels.querySelectorAll('[data-dual-panel-content-panel]').forEach((panel, index) => {
        panel.classList.toggle('is-active', index === activeIndex);
      });
    };

    slider.addEventListener('scroll', updatePanels, {passive: true});
    slideshow.addEventListener('click', (event) => {
      if (event.target.closest('.slider-counter__link, .slider-button')) {
        requestAnimationFrame(updatePanels);
      }
    });

    window.requestAnimationFrame(updatePanels);
    window.setTimeout(updatePanels, 150);
  };

  document.querySelectorAll('.dual-panel-showcase__slider').forEach((slideshow) => {
    syncDualPanelContent(slideshow);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.dual-panel-showcase__slider').forEach((slideshow) => {
      syncDualPanelContent(slideshow);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const nextSectionButton = event.target.closest('[data-action="navigate-next"]');
    if (nextSectionButton) {
      nextSectionButton.closest('.shopify-section')?.nextElementSibling?.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
      return;
    }

    const unmuteButton = event.target.closest('[data-hero-slideshow-unmute]');
    if (unmuteButton) {
      const slide = unmuteButton.closest('.hero-slideshow__slide');
      slide?.querySelectorAll('video').forEach((video) => {
        video.muted = false;
      });
      unmuteButton.hidden = true;
      slide?.querySelector('[data-hero-slideshow-mute]')?.removeAttribute('hidden');
      return;
    }

    const muteButton = event.target.closest('[data-hero-slideshow-mute]');
    if (muteButton) {
      const slide = muteButton.closest('.hero-slideshow__slide');
      slide?.querySelectorAll('video').forEach((video) => {
        video.muted = true;
      });
      muteButton.hidden = true;
      slide?.querySelector('[data-hero-slideshow-unmute]')?.removeAttribute('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
